import { useCallback, useMemo } from 'react';
import type { RevieveInitConfig } from 'revieve';

import type { NovageSkincareConfiguration } from '../models';
import { hideRevieve, initRevieve, showRevieve, unmountRevieve } from '../utils';
import { useSessionStorage } from './useSessionStorage';

export interface UseRevieveAdvisorProps {
  novageSkincareConfiguration: NovageSkincareConfiguration;
}

export const useRevieveAdvisor = ({ novageSkincareConfiguration }: UseRevieveAdvisorProps) => {
  const { clear } = useSessionStorage({ novageSkincareConfiguration });
  const reset = useCallback(
    (config: RevieveInitConfig) => {
      unmountRevieve();
      clear();
      initRevieve(config);
    },
    [clear],
  );

  return useMemo(() => ({ close: hideRevieve, open: showRevieve, reset }), [reset]);
};
